export default "__VITE_ASSET__DUEZQSWp__"